
import React from 'react';

type Props = {
  className?: string;
};

const Icon: React.FC<Props> = ({ className }: Props) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <mask id="mask0_9399_22931" style={{maskType:'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
      <rect width="16" height="16" fill="#D9D9D9"/>
    </mask>
    <g mask="url(#mask0_9399_22931)">
      <path d="M4.7974 14.3996L3.66406 13.2663L8.93073 7.99961L3.66406 2.73294L4.7974 1.59961L11.1974 7.99961L4.7974 14.3996Z" fill="#0B57D0"/>
    </g>
  </svg>
);

export default Icon;
